// Webpack Imports
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

gsap.registerPlugin(ScrollTrigger);

(function () {
    'use strict';

    let lenis = null;

    /**
     * Lenis smooth scroll + GSAP ScrollTrigger sync.
     *
     * @returns {Lenis|null}
     */
    const initLenis = () => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return null;
        }

        lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            smoothTouch: false,
        });


        lenis.on('scroll', ScrollTrigger.update);

        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);

        return lenis;
    };

    const refreshScroll = () => {
        lenis?.resize();
        ScrollTrigger.refresh();
    };

    initLenis();

    function updateEvenViewport() {
        const width = document.documentElement.clientWidth;

        const evenWidth = width % 2
            ? width - 1
            : width;
        const gLayer = document.querySelector('.gradient-layer');
        if (gLayer) {
            gLayer.style.width = `${evenWidth}px`;
        }
    }

    updateEvenViewport();
    window.addEventListener('resize', updateEvenViewport);
    let lastScrollTop = 0;
    const header = document.querySelector('.site-header');
    if (header) {
        window.addEventListener('scroll', () => {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > lastScrollTop && scrollTop > 100) {
                // اسکرول به پایین
                header.classList.add('hide');
            } else if (scrollTop <= 50) {
                // اسکرول به بالا
                header.classList.remove('hide');
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        });
    }
    const initLangSwitcher = () => {
        const switchers = document.querySelectorAll('.lang-switcher');

        if (!switchers.length) {
            return;
        }

        const closeSwitcher = (switcher) => {
            const toggle = switcher.querySelector('.lang-switcher__toggle');
            const menu = switcher.querySelector('.lang-switcher__menu');

            switcher.classList.remove('is-open');
            toggle?.setAttribute('aria-expanded', 'false');
            if (menu) {
                menu.hidden = true;
            }
        };

        const closeAll = (except = null) => {
            switchers.forEach((switcher) => {
                if (switcher !== except) {
                    closeSwitcher(switcher);
                }
            });
        };

        switchers.forEach((switcher) => {
            const toggle = switcher.querySelector('.lang-switcher__toggle');
            const menu = switcher.querySelector('.lang-switcher__menu');

            if (!toggle || !menu) {
                return;
            }

            toggle.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const willOpen = !switcher.classList.contains('is-open');
                closeAll(switcher);

                if (willOpen) {
                    switcher.classList.add('is-open');
                    toggle.setAttribute('aria-expanded', 'true');
                    menu.hidden = false;
                } else {
                    closeSwitcher(switcher);
                }
            });
        });

        document.addEventListener('click', (event) => {
            if (!event.target.closest('.lang-switcher')) {
                closeAll();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeAll();
            }
        });
    };
    const initBrandCarouselScroll = () => {
        const wrap = document.querySelector('.brand-carousel-wrap');
        if (!wrap) {
            return;
        }

        const fromLeft = wrap.querySelector('.brands-carousel.from-left');
        const fromRight = wrap.querySelector('.brands-carousel.from-right');

        if (!fromLeft || !fromRight) {
            return;
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        const leftTrack = fromLeft.closest('.brand-carousel-track');
        const rightTrack = fromRight.closest('.brand-carousel-track');

        let scrollTriggerInstance = null;
        let timeline = null;

        const getCarouselTravel = (carousel, track) => {
            if (!carousel || !track) {
                return 0;
            }

            const lastBox = carousel.querySelector('.brand-box:last-child');
            if (!lastBox) {
                return 0;
            }

            const trackWidth = track.clientWidth;
            const carouselWidth = carousel.scrollWidth;
            const overflow = carouselWidth - trackWidth;

            if (overflow <= 0) {
                return 0;
            }

            const lastBoxEnd = lastBox.offsetLeft + lastBox.offsetWidth;

            return Math.max(overflow, lastBoxEnd - trackWidth);
        };

        const killAnimation = () => {
            scrollTriggerInstance?.kill();
            timeline?.kill();
            scrollTriggerInstance = null;
            timeline = null;
            gsap.set([fromLeft, fromRight], {clearProps: 'transform'});
        };

        const buildAnimation = () => {
            killAnimation();

            gsap.set(fromLeft, {x: 0});
            gsap.set(fromRight, {x: 0});

            const leftTravel = getCarouselTravel(fromLeft, leftTrack);
            const rightTravel = getCarouselTravel(fromRight, rightTrack);
            const scrollDistance = Math.max(leftTravel, rightTravel);

            if (scrollDistance <= 0) {
                return;
            }

            timeline = gsap.timeline({
                defaults: {ease: 'none', force3D: true},
            });

            timeline
                .to(fromLeft, {x: -leftTravel}, 0)
                .to(fromRight, {x: rightTravel}, 0);

            scrollTriggerInstance = ScrollTrigger.create({
                trigger: wrap,
                start: 'top top',
                end: `+=${scrollDistance}`,
                pin: true,
                scrub: 1,
                anticipatePin: 1,
                animation: timeline,
                invalidateOnRefresh: true,
            });
        };

        // ScrollTrigger.matchMedia({
        //     '(min-width: 992px)': () => {
        //         const refresh = () => {
        //             buildAnimation();
        //             refreshScroll();
        //         };
        //
        //         refresh();
        //         window.addEventListener('load', refresh);
        //
        //         return () => {
        //             killAnimation();
        //             window.removeEventListener('load', refresh);
        //         };
        //     },
        //     '(max-width: 991px)': () => killAnimation,
        // });
        const refresh = () => {
            buildAnimation();
            refreshScroll();
        };

        refresh();

        window.addEventListener('load', refresh);

        window.addEventListener('resize', refresh);
    };

    const initMobileMenu = () => {
        const menuPanel = document.getElementById('navbar');
        const toggler = document.querySelector('[data-mobile-menu-toggle]');
        const closeBtn = document.querySelector('.mobile-menu-close');
        const desktopQuery = window.matchMedia('(min-width: 992px)');

        if (!menuPanel || !toggler) {
            return;
        }

        const isDesktop = () => desktopQuery.matches;

        const resetMobileAccordions = () => {
            menuPanel.querySelectorAll('.mega-mobile-accordion').forEach((accordion) => {
                accordion.hidden = true;
                accordion.classList.remove('is-open');
                accordion.querySelectorAll('.mega-mobile-sub').forEach((sub) => {
                    sub.hidden = true;
                });
                accordion.querySelectorAll('.mega-mobile-toggle').forEach((toggle) => {
                    toggle.setAttribute('aria-expanded', 'false');
                });
            });

            menuPanel.querySelectorAll('.mega-menu-trigger').forEach((trigger) => {
                trigger.setAttribute('aria-expanded', 'false');
            });

            menuPanel.querySelectorAll('.nav-item.has-mega-menu').forEach((item) => {
                item.classList.remove('is-open');
            });
        };

        const closeMobileMenu = () => {
            menuPanel.classList.remove('is-open');
            toggler.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('mobile-menu-open');
            resetMobileAccordions();
        };

        const openMobileMenu = () => {
            menuPanel.classList.add('is-open');
            toggler.setAttribute('aria-expanded', 'true');
            document.body.classList.add('mobile-menu-open');
        };

        toggler.addEventListener('click', () => {
            if (isDesktop()) {
                return;
            }

            if (menuPanel.classList.contains('is-open')) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });

        closeBtn?.addEventListener('click', closeMobileMenu);

        menuPanel.addEventListener('click', (event) => {
            if (isDesktop()) {
                return;
            }

            const link = event.target.closest('.mega-mobile-link:not(.mega-mobile-link--l4), .nav-link:not(.mega-menu-trigger)');
            if (link?.getAttribute('href') && link.getAttribute('href') !== '#') {
                closeMobileMenu();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && menuPanel.classList.contains('is-open') && !isDesktop()) {
                closeMobileMenu();
            }
        });

        const handleViewportChange = () => {
            if (isDesktop()) {
                closeMobileMenu();
            }
        };

        if (typeof desktopQuery.addEventListener === 'function') {
            desktopQuery.addEventListener('change', handleViewportChange);
        } else {
            desktopQuery.addListener(handleViewportChange);
        }
    };

    const initMegaMenu = () => {
        const header = document.querySelector('header');
        const backdrop = document.querySelector('.mega-menu-backdrop');
        const triggers = document.querySelectorAll('.mega-menu-trigger');
        const panels = document.querySelectorAll('.mega-menu-panel');
        const desktopQuery = window.matchMedia('(min-width: 992px)');

        if (!header || !triggers.length) {
            return;
        }

        const isDesktopMega = () => desktopQuery.matches;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let activePanel = null;
        let activeTrigger = null;

        const closeMobileAccordion = (accordion, trigger) => {
            accordion.hidden = true;
            accordion.classList.remove('is-open');
            trigger?.setAttribute('aria-expanded', 'false');
            trigger?.closest('.nav-item')?.classList.remove('is-open');
            accordion.querySelectorAll('.mega-mobile-sub').forEach((sub) => {
                sub.hidden = true;
            });
            accordion.querySelectorAll('.mega-mobile-toggle').forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'false');
            });
        };

        const toggleMobileAccordion = (accordion, trigger) => {
            const navItem = trigger.closest('.nav-item');
            const willOpen = accordion.hidden;

            document.querySelectorAll('.mega-mobile-accordion').forEach((item) => {
                if (item !== accordion) {
                    closeMobileAccordion(item, item.closest('.nav-item')?.querySelector('.mega-menu-trigger'));
                }
            });

            accordion.hidden = !willOpen;
            accordion.classList.toggle('is-open', willOpen);
            trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            navItem?.classList.toggle('is-open', willOpen);

            if (!willOpen) {
                closeMobileAccordion(accordion, trigger);
            }
        };

        const toggleMobileSub = (toggle) => {
            const sub = document.getElementById(toggle.getAttribute('aria-controls'));
            if (!sub) {
                return;
            }

            const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
            const parentSub = toggle.closest('.mega-mobile-sub');

            parentSub?.querySelectorAll(':scope > .mega-mobile-list > .mega-mobile-item > .mega-mobile-toggle').forEach((siblingToggle) => {
                if (siblingToggle === toggle) {
                    return;
                }

                const siblingSub = document.getElementById(siblingToggle.getAttribute('aria-controls'));
                siblingToggle.setAttribute('aria-expanded', 'false');
                if (siblingSub) {
                    siblingSub.hidden = true;
                }
            });

            toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            sub.hidden = !willOpen;
        };

        const closeMegaMenu = () => {
            if (!activePanel) {
                return;
            }

            const panelToClose = activePanel;
            const triggerToClose = activeTrigger;

            const finishClose = () => {
                panelToClose.classList.remove('is-open');
                panelToClose.setAttribute('aria-hidden', 'true');
                panelToClose.hidden = true;
                panelToClose.style.removeProperty('height');
                panelToClose.style.removeProperty('max-height');
                panelToClose.style.removeProperty('--mega-panel-height');
                triggerToClose?.classList.remove('is-open');
                triggerToClose?.setAttribute('aria-expanded', 'false');
                backdrop?.classList.remove('is-visible');
                document.body.classList.remove('mega-menu-open');
                activePanel = null;
                activeTrigger = null;
            };

            if (prefersReducedMotion) {
                gsap.set(panelToClose, {clearProps: 'height,opacity,maxHeight'});
                finishClose();
                return;
            }

            gsap.to(panelToClose, {
                height: 0,
                opacity: 0,
                duration: 0.25,
                ease: 'power2.in',
                onComplete: () => {
                    gsap.set(panelToClose, {clearProps: 'height,opacity,maxHeight'});
                    finishClose();
                },
            });
        };

        const getMegaPanelMaxHeight = () => Math.round(window.innerHeight * 0.7);

        const openMegaMenu = (panel, trigger) => {
            if (activePanel === panel) {
                closeMegaMenu();
                return;
            }

            if (activePanel) {
                activePanel.classList.remove('is-open');
                activePanel.setAttribute('aria-hidden', 'true');
                activePanel.hidden = true;
                activeTrigger?.classList.remove('is-open');
                activeTrigger?.setAttribute('aria-expanded', 'false');
                gsap.set(activePanel, {clearProps: 'height,opacity,maxHeight'});
            }

            activePanel = panel;
            activeTrigger = trigger;

            panel.hidden = false;
            panel.setAttribute('aria-hidden', 'false');
            panel.classList.add('is-open');
            trigger.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            backdrop?.classList.add('is-visible');
            document.body.classList.add('mega-menu-open');

            const maxHeight = getMegaPanelMaxHeight();
            panel.style.setProperty('--mega-panel-height', `${maxHeight}px`);

            if (prefersReducedMotion) {
                panel.style.height = `${maxHeight}px`;
                panel.style.maxHeight = `${maxHeight}px`;
                lenis?.resize();
                return;
            }

            gsap.set(panel, {height: maxHeight, maxHeight, opacity: 1});
            gsap.fromTo(
                panel,
                {height: 0, opacity: 0},
                {
                    height: maxHeight,
                    maxHeight,
                    opacity: 1,
                    duration: 0.35,
                    ease: 'power2.out',
                    onComplete: () => {
                        panel.style.height = `${maxHeight}px`;
                        panel.style.maxHeight = `${maxHeight}px`;
                        lenis?.resize();
                    },
                }
            );
        };

        const setFeatureImage = (panel, imageUrl) => {
            if (!imageUrl) {
                return;
            }

            const featureWrap = panel.querySelector('.mega-menu-l2-panel.is-active .mega-menu-feature');
            if (!featureWrap) {
                return;
            }

            const placeholder = featureWrap.querySelector('.mega-menu-feature-placeholder');
            if (placeholder) {
                placeholder.remove();
            }

            let img = featureWrap.querySelector('.mega-menu-feature-img');

            if (img?.dataset.current === imageUrl) {
                return;
            }

            gsap.killTweensOf(featureWrap.querySelectorAll('.mega-menu-feature-img'));

            if (!img) {
                img = document.createElement('img');
                img.className = 'mega-menu-feature-img is-visible';
                featureWrap.appendChild(img);
                img.src = imageUrl;
                img.dataset.current = imageUrl;
                return;
            }

            if (prefersReducedMotion) {
                featureWrap.querySelectorAll('.mega-menu-feature-img').forEach((image, index) => {
                    if (index > 0) {
                        image.remove();
                    }
                });
                img.src = imageUrl;
                img.dataset.current = imageUrl;
                img.classList.add('is-visible');
                gsap.set(img, {opacity: 1});
                return;
            }

            const fadeOutDuration = 0.25;
            const fadeInDuration = 0.3;
            const crossfadeOverlap = 0.12;

            const nextImg = document.createElement('img');
            nextImg.className = 'mega-menu-feature-img';
            nextImg.alt = img.alt || '';
            nextImg.dataset.current = imageUrl;
            gsap.set(nextImg, {opacity: 0});

            const startCrossfade = () => {
                if (nextImg.dataset.crossfading === 'true') {
                    return;
                }

                nextImg.dataset.crossfading = 'true';
                featureWrap.appendChild(nextImg);

                gsap.to(img, {
                    opacity: 0,
                    duration: fadeOutDuration,
                    ease: 'power2.out',
                });

                gsap.to(nextImg, {
                    opacity: 1,
                    duration: fadeInDuration,
                    delay: fadeOutDuration - crossfadeOverlap,
                    ease: 'power2.out',
                    onComplete: () => {
                        img.remove();
                        nextImg.classList.add('is-visible');
                        gsap.set(nextImg, {clearProps: 'opacity'});
                    },
                });
            };

            nextImg.addEventListener('load', startCrossfade, {once: true});
            nextImg.addEventListener('error', startCrossfade, {once: true});
            nextImg.src = imageUrl;

            if (nextImg.complete) {
                startCrossfade();
            }
        };

        const activateL2Panel = (panel, targetId) => {
            panel.querySelectorAll('.mega-menu-l2-item').forEach((item) => {
                const btn = item.querySelector('.mega-menu-l2-btn');
                const isActive = btn?.getAttribute('data-l2-target') === targetId;
                item.classList.toggle('is-active', isActive);
                btn?.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });

            panel.querySelectorAll('.mega-menu-l2-panel').forEach((l2Panel) => {
                const isActive = l2Panel.id === targetId;
                l2Panel.classList.toggle('is-active', isActive);
                l2Panel.hidden = !isActive;
            });

            const activeL2 = panel.querySelector(`#${targetId}`);
            const firstFeature = activeL2?.querySelector('[data-feature-image]');
            if (firstFeature?.dataset.featureImage) {
                setFeatureImage(panel, firstFeature.dataset.featureImage);
            }
        };

        const activateL3Group = (l2Panel, groupId, featureImage) => {
            l2Panel.querySelectorAll('.mega-menu-l3-item').forEach((item) => {
                const btn = item.querySelector('[data-l3-group]');
                item.classList.toggle('is-active', btn?.dataset.l3Group === groupId);
            });

            l2Panel.querySelectorAll('.mega-menu-l4-group').forEach((group) => {
                const isActive = group.dataset.l3Group === groupId;
                group.classList.toggle('is-active', isActive);
                group.hidden = !isActive;
            });

            const panel = l2Panel.closest('.mega-menu-panel');
            if (panel && featureImage) {
                setFeatureImage(panel, featureImage);
            }
        };

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();

                if (!isDesktopMega()) {
                    const accordion = document.getElementById(trigger.dataset.mobileAccordion);
                    if (accordion) {
                        toggleMobileAccordion(accordion, trigger);
                    }
                    return;
                }

                const panel = document.getElementById(trigger.dataset.megaTarget);
                if (panel) {
                    openMegaMenu(panel, trigger);
                }
            });
        });

        header.addEventListener('click', (event) => {
            if (isDesktopMega()) {
                return;
            }

            const mobileToggle = event.target.closest('.mega-mobile-toggle');
            if (mobileToggle) {
                event.preventDefault();
                toggleMobileSub(mobileToggle);
            }
        });

        if (backdrop) {
            backdrop.addEventListener('click', closeMegaMenu);
        }

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && isDesktopMega()) {
                closeMegaMenu();
            }
        });

        if (panels.length) {
            const panelsContainer = document.querySelector('.mega-menu-panels');

            const handleMegaPanelInteraction = (event) => {
                if (!isDesktopMega()) {
                    return;
                }

                const l2Btn = event.target.closest('.mega-menu-l2-btn');
                if (l2Btn) {
                    const panel = l2Btn.closest('.mega-menu-panel');
                    const targetId = l2Btn.getAttribute('data-l2-target');
                    const l2Item = l2Btn.closest('.mega-menu-l2-item');
                    const isActiveTab = l2Item?.classList.contains('is-active');

                    if (!panel || !targetId) {
                        return;
                    }

                    if (isActiveTab) {
                        return;
                    }

                    event.preventDefault();
                    activateL2Panel(panel, targetId);
                    return;
                }

                const l3Btn = event.target.closest('.mega-menu-l3-btn');
                if (l3Btn?.dataset.l3Group) {
                    const l3Item = l3Btn.closest('.mega-menu-l3-item');
                    if (l3Item?.classList.contains('is-active')) {
                        return;
                    }

                    event.preventDefault();
                    const l2Panel = l3Btn.closest('.mega-menu-l2-panel');
                    if (l2Panel) {
                        activateL3Group(l2Panel, l3Btn.dataset.l3Group, l3Btn.dataset.featureImage);
                    }
                }
            };

            const handleMegaPanelHover = (event) => {
                if (!isDesktopMega()) {
                    return;
                }

                const l3Link = event.target.closest('.mega-menu-l3-link');
                if (!l3Link) {
                    return;
                }

                const panel = l3Link.closest('.mega-menu-panel');
                const l2Panel = l3Link.closest('.mega-menu-l2-panel');
                const l3Item = l3Link.closest('.mega-menu-l3-item');

                l2Panel?.querySelectorAll('.mega-menu-l3-item').forEach((item) => {
                    item.classList.toggle('is-active', item === l3Item);
                });

                if (l3Link.dataset.featureImage && panel) {
                    setFeatureImage(panel, l3Link.dataset.featureImage);
                }
            };

            panelsContainer?.addEventListener('click', handleMegaPanelInteraction);
            panelsContainer?.addEventListener('mouseover', handleMegaPanelHover);
        }

        const handleViewportChange = () => {
            if (!isDesktopMega()) {
                closeMegaMenu();
            } else {
                document.querySelectorAll('.mega-mobile-accordion').forEach((accordion) => {
                    closeMobileAccordion(accordion, accordion.closest('.nav-item')?.querySelector('.mega-menu-trigger'));
                });
            }
        };

        if (typeof desktopQuery.addEventListener === 'function') {
            desktopQuery.addEventListener('change', handleViewportChange);
        } else {
            desktopQuery.addListener(handleViewportChange);
        }
    };

    if (document.querySelector('#other-category')) {
        new Swiper('#other-category', {
            slidesPerView: 1.5,
            spaceBetween: 16,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {slidesPerView: 2},
                992: {slidesPerView: 4, spaceBetween: 24},
            },
        });
    }
    const swipers = {};

    function initSwiper(container) {

        const slider = container.querySelector('.product-swiper');

        if (!slider) return;

        if (swipers[slider.id]) {
            swipers[slider.id].update();
            return;
        }

        swipers[slider.id] = new Swiper(slider, {
            modules: [Navigation],

            slidesPerView: 2,
            spaceBetween: 16,
            centeredSlides: true,
            loop: false,
            observer: true,
            observeParents: true,

            navigation: {
                nextEl: container.querySelector('.swiper-button-next'),
                prevEl: container.querySelector('.swiper-button-prev'),
            },

            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 5,
                    spaceBetween: 24,
                },
            },
        });

    }
    const firstPane = document.querySelector('.tab-pane.active');
    if (firstPane) {
        initSwiper(firstPane);
    }

// تب‌های بعدی
    document.querySelectorAll('[data-bs-toggle="tab"]').forEach(tab => {

        tab.addEventListener('shown.bs.tab', function (e) {

            const target = document.querySelector(
                e.target.getAttribute('data-bs-target')
            );

            initSwiper(target);

        });

    });

    const initInnovationAccordion = () => {
        const accordion = document.getElementById('innovationAccordion');
        if (!accordion) {
            return;
        }

        const panels = accordion.querySelectorAll('.innovation-accordion__panel');
        const closeDuration = 320;
        const openDuration = 760;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const activatePanel = (panel, trigger) => {
            panel.classList.add('is-active');
            trigger.setAttribute('aria-expanded', 'true');

            window.setTimeout(() => {
                accordion.classList.remove('is-changing');
            }, prefersReducedMotion ? 0 : openDuration);
        };

        const deactivatePanel = (panel) => {
            panel.classList.add('is-closing');
            panel.querySelector('.innovation-accordion__trigger')?.setAttribute('aria-expanded', 'false');

            window.setTimeout(() => {
                panel.classList.remove('is-active', 'is-closing');
            }, prefersReducedMotion ? 0 : closeDuration);
        };

        panels.forEach((panel) => {
            const trigger = panel.querySelector('.innovation-accordion__trigger');
            if (!trigger) {
                return;
            }

            trigger.addEventListener('click', () => {
                if (panel.classList.contains('is-active') || accordion.classList.contains('is-changing')) {
                    return;
                }

                const currentActive = accordion.querySelector('.innovation-accordion__panel.is-active');
                accordion.classList.add('is-changing');

                if (currentActive && currentActive !== panel) {
                    deactivatePanel(currentActive);

                    window.setTimeout(() => {
                        activatePanel(panel, trigger);
                    }, prefersReducedMotion ? 0 : closeDuration);
                    return;
                }

                activatePanel(panel, trigger);
            });
        });
    };

    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });

    initBrandCarouselScroll();
    initMobileMenu();
    initMegaMenu();
    initInnovationAccordion();
    initLangSwitcher();

    window.addEventListener('load', refreshScroll);
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(refreshScroll, 250);
    });
    const isTouch = window.matchMedia("(hover: none)").matches;

    function positionHotspotTooltip(wrapper, tooltip, hotspot, options = {}) {
        const { withOverlay = true } = options;

        if (withOverlay) {
            wrapper.classList.add('active');
        } else {
            wrapper.classList.remove('active');
        }

        tooltip.querySelector('.tooltip-title').textContent = hotspot.dataset.title || '';
        tooltip.querySelector('.tooltip-text').textContent = hotspot.dataset.text || '';

        // Jump to the new point without animating left/top (avoids tooltip sliding across map).
        const previousTransition = tooltip.style.transition;
        tooltip.style.transition = 'none';
        tooltip.classList.remove('show');

        const wrapperRect = wrapper.getBoundingClientRect();
        const pointRect = hotspot.getBoundingClientRect();
        const tipWidth = tooltip.offsetWidth || 140;
        const tipHeight = tooltip.offsetHeight || 64;

        let left = pointRect.left - wrapperRect.left + pointRect.width / 2;
        let top = pointRect.top - wrapperRect.top - tipHeight - 16;

        if (left < tipWidth / 2 + 10)
            left = tipWidth / 2 + 10;

        if (left > wrapper.clientWidth - tipWidth / 2 - 10)
            left = wrapper.clientWidth - tipWidth / 2 - 10;

        if (top < 10)
            top = pointRect.bottom - wrapperRect.top + 16;

        tooltip.style.left = left + "px";
        tooltip.style.top = top + "px";

        // Force reflow, then fade in at the new spot.
        void tooltip.offsetWidth;
        tooltip.style.transition = previousTransition;
        tooltip.classList.add('show');
    }

    document.querySelectorAll('.world-map-wrapper').forEach(wrapper => {
        if (wrapper.closest('#factories')) return;

        const tooltip = wrapper.querySelector('.hotspot-tooltip');
        const hotspots = wrapper.querySelectorAll('.hotspot');

        if (!tooltip || !hotspots.length) return;

        function showTooltip(hotspot) {
            positionHotspotTooltip(wrapper, tooltip, hotspot);
        }

        function hideTooltip() {
            wrapper.classList.remove('active');
            tooltip.classList.remove('show');
        }

        if (isTouch) {
            hotspots.forEach(hotspot => {
                hotspot.addEventListener("click", e => {
                    e.stopPropagation();
                    showTooltip(hotspot);
                });
            });

            document.addEventListener("click", hideTooltip);
        } else {
            hotspots.forEach(hotspot => {
                hotspot.addEventListener("mouseenter", () => {
                    showTooltip(hotspot);
                });

                hotspot.addEventListener("mouseleave", () => {
                    hideTooltip();
                });
            });
        }
    });

    const factoriesSection = document.querySelector('#factories');
    if (factoriesSection) {
        const wrapper = factoriesSection.querySelector('.world-map-wrapper');
        const tooltip = wrapper?.querySelector('.hotspot-tooltip');
        const locationPanels = factoriesSection.querySelectorAll('.location-panel');
        const factoryHotspots = factoriesSection.querySelectorAll('.hotspot[data-location]');
        const desktopMq = window.matchMedia('(min-width: 992px)');
        let activeHotspot = null;

        function showLocationPanel(locationId) {
            if (!locationId) return;

            locationPanels.forEach(panel => {
                const isActive = panel.id === locationId;
                panel.classList.toggle('is-active', isActive);
                panel.hidden = !isActive;
            });
        }

        function clearFactoriesTooltip() {
            if (!wrapper || !tooltip) return;
            wrapper.classList.remove('active');
            tooltip.classList.remove('show');
            factoryHotspots.forEach(item => item.classList.remove('is-active'));
        }

        function activateHotspot(hotspot) {
            if (!hotspot || !wrapper || !tooltip || !desktopMq.matches) return;
            if (activeHotspot === hotspot && tooltip.classList.contains('show')) {
                showLocationPanel(hotspot.dataset.location);
                return;
            }

            activeHotspot = hotspot;
            factoryHotspots.forEach(item => item.classList.toggle('is-active', item === hotspot));
            showLocationPanel(hotspot.dataset.location);
            positionHotspotTooltip(wrapper, tooltip, hotspot, { withOverlay: false });
        }

        factoryHotspots.forEach(hotspot => {
            hotspot.addEventListener('click', e => {
                if (!desktopMq.matches) return;
                e.preventDefault();
                e.stopPropagation();
                activateHotspot(hotspot);
            });
        });

        function syncFactoriesDesktop() {
            if (!desktopMq.matches) {
                clearFactoriesTooltip();
                return;
            }

            const defaultHotspot =
                activeHotspot ||
                factoriesSection.querySelector('.hotspot[data-location="tehran-locations"]') ||
                factoryHotspots[0];

            if (defaultHotspot) {
                activateHotspot(defaultHotspot);
            }
        }

        syncFactoriesDesktop();
        desktopMq.addEventListener('change', syncFactoriesDesktop);

        window.addEventListener('resize', () => {
            if (desktopMq.matches && activeHotspot) {
                positionHotspotTooltip(wrapper, tooltip, activeHotspot, { withOverlay: false });
            }
        });
    }
})();
